(function(args) { 

	var owlClassName = 'owl-carousel '+args.id;
	var attributes = args.attributes;

	var carouselOptions = {
	    items:attributes.itemsShow,
	    nav: (attributes.arrowsShow) ? true : false,
	    loop:true,
	    margin:10,
	    autoplay:(attributes.autoplay) ? true : false,
	    autoplayTimeout:attributes.autoplayTimeout,
	    autoplaySpeed:1500,
	    autoplayHoverPause:true, 
		responsive : {
		    0 : {
		        items : attributes.itemsShow480,
		    },
		    480 : {
		        items : attributes.itemsShow768,
		    },
		    768 : {
		        items : attributes.itemsShow1024,
		    },
		    1024 : {
		        items : attributes.itemsShow,
		    }		    
		}	
	}

	document.getElementById(args.id).innerHTML = `
		<div class="${owlClassName}">
			${args.items}
		</div>	
	`;

        document.addEventListener('readystatechange', () => {
          	if (document.readyState === 'interactive') {
				const $carousel = jQuery('.' + args.id);

				$carousel.owlCarousel(carouselOptions);

				//fix
				$carousel.on('changed.owl.carousel', function(event) {
					$carousel.find('.owl-item').find('.img-load img').addClass('loaded');
					$carousel.find('.owl-item').find('.img-load').removeClass('background-placeholder');
					$carousel.find('.owl-item').find('.img-load .loader').addClass('hide');
				});

				$carousel.on('click', '.owl-prev, .owl-next, .owl-dot', function () {
					$carousel.find('.owl-item').find('.img-load img').addClass('loaded');
					$carousel.find('.owl-item').find('.img-load').removeClass('background-placeholder');
					$carousel.find('.owl-item').find('.img-load .loader').addClass('hide');
				});

				$carousel.on('click', 'owl-prev, .owl-next, .owl-dot', function() { 
				  $carousel.trigger('stop.owl.autoplay');
				});
			}
    	});

})(args);